import createStore from 'global/helpers/createStore'
import { MeasurementsSystem } from 'screens/UserManager/UserManager.types'

export interface GuestUserState {
  measurementsSystem: MeasurementsSystem
}

export type GuestUserAction = { type: 'setMeasurementsSystem'; payload: MeasurementsSystem }

const getDefaultMeasurementsSystem = (): MeasurementsSystem => {
  const stored = localStorage.getItem('measurementsSystem')
  if (stored) {
    return MeasurementsSystem[stored]
  }

  const locale = new Intl.Locale(navigator.language)
  const region = locale.region
  if (!region) {
    return MeasurementsSystem.METRIC
  }
  // United States, Liberia, Myanmar uses imperial
  return ['US', 'LR', 'MM'].includes(region) ? MeasurementsSystem.IMPERIAL : MeasurementsSystem.METRIC
}

const initialState: GuestUserState = {
  measurementsSystem: getDefaultMeasurementsSystem(),
}

const reducer = (state: GuestUserState, action: GuestUserAction): GuestUserState => {
  switch (action.type) { // NOSONAR - typescript:S1301 keeping switch statement for consistency
    case 'setMeasurementsSystem':
      localStorage.setItem('measurementsSystem', action.payload)
      return {
        ...state,
        measurementsSystem: action.payload,
      }
    default:
      throw new Error('Invalid action type')
  }
}

const { StoreContext, StoreProvider } = createStore(reducer, initialState)

export { StoreContext as GuestUserContext, StoreProvider as GuestUserProvider }
